import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowLeft } from "lucide-react";
import { PAYMENT as P } from "@/constants/testIds";

export default function PaymentCancel() {
  return (
    <div
      data-testid={P.cancelPage}
      className="font-body bg-cream min-h-screen flex items-center justify-center px-6 text-ink antialiased"
    >
      <motion.div
        initial={{ opacity: 0, y: 24 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
        className="max-w-lg w-full text-center rounded-2xl border border-line bg-white p-10 sm:p-14 shadow-[0_20px_40px_rgb(0,0,0,0.06)]"
      >
        <p className="font-body text-xs font-semibold uppercase tracking-[0.22em] text-clay">
          THE CALLED CREATOR HOUSE
        </p>
        <h1 className="mt-4 font-heading text-3xl sm:text-4xl tracking-tight text-ink leading-tight">
          your checkout was cancelled
        </h1>
        <p className="mt-4 text-base sm:text-lg text-stone-text leading-relaxed">
          No worries — you haven't been charged. Whenever you're ready, your spot in the 4-week live cohort is still here.
        </p>

        <div className="mt-9 flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/creator-house"
            data-testid={P.cancelRetryCta}
            className="inline-flex items-center justify-center rounded-full bg-sage px-8 py-3.5 text-base font-semibold text-white transition-[transform,background-color] duration-300 hover:bg-sage-dark hover:scale-[1.03]"
          >
            Back to the Creator House
          </Link>
          <Link
            to="/creator-house"
            data-testid={P.cancelBackCta}
            className="inline-flex items-center justify-center gap-2 rounded-full border border-line bg-white px-6 py-3.5 text-base font-semibold text-ink transition-colors duration-300 hover:bg-cream"
          >
            <ArrowLeft className="h-4 w-4" aria-hidden="true" />
            Take another look
          </Link>
        </div>
      </motion.div>
    </div>
  );
}
